import { API_ORIGIN } from '../config'
const API_BASE = `${API_ORIGIN}/api`

export async function getPlotDetail(plotId) {
  const response = await fetch(`${API_BASE}/plots/${plotId}`)
  if (!response.ok) throw new Error('Error al obtener el detalle de la nave')
  return response.json()
}

// Convierte la respuesta de error del servidor en un Error con `code` y el mensaje legible (p. ej. límite del plan).
async function failure(response, fallback) {
  const data = await response.json().catch(() => ({}))
  const error = new Error(data.message || fallback)
  error.code = data.error
  return error
}

export async function createPlot(parkId, data) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/plots`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  })
  if (!response.ok) throw await failure(response, 'Error al registrar la nave')
  return response.json()
}

// dryRun: true no crea nada y devuelve { duplicates: [{ index, name, reason: 'EXISTING' | 'IN_FILE' }] }.
// Una fila con allowDuplicate: true se crea aunque su nombre esté repetido; sin esa marca, las repetidas se omiten.
export async function createPlotsBulk(parkId, rows, { dryRun = false } = {}) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/plots/bulk`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ rows, dryRun }),
  })
  if (!response.ok) throw await failure(response, 'Error al importar las naves')
  return response.json()
}
export async function updatePlotStatus(plotId, payload) {
  const response = await fetch(`${API_BASE}/plots/${plotId}/status`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })
  if (!response.ok) throw await failure(response, 'No se pudo cambiar el estado de la nave')
  return response.json()
}

export async function getPlotDeleteCheck(plotId) {
  const response = await fetch(`${API_BASE}/plots/${plotId}/delete-check`)
  if (!response.ok) throw await failure(response, 'No se pudo revisar la nave')
  return response.json()
}

export async function deletePlot(plotId) {
  const response = await fetch(`${API_BASE}/plots/${plotId}`, { method: 'DELETE' })
  if (!response.ok) throw await failure(response, 'No se pudo eliminar la nave')
  return response.json()
}